let dates;
export function getFormattedDate(date) {
  dates = new Date(date);
  return `${dates.getFullYear()}-${dates.getMonth()}-${dates.getDate()}`;
}
export const baseUrl = "https://awakilo.com/api/api/v1"; 
